const mediaItems = [
  {
    title: '韩漫入门指南：从零开始的韩漫之旅',
    desc: '全面解析韩国漫画的特色与魅力，带你了解韩漫的分类、推荐入坑作品以及阅读技巧。',
    cover: 'https://readdy.ai/api/search-image?query=A%20colorful%20Korean%20webtoon%20style%20illustration%20with%20vertical%20scrolling%20panels%2C%20vibrant%20characters%20in%20modern%20Seoul%20setting%2C%20warm%20pastel%20color%20palette%2C%20clean%20digital%20art%20aesthetic%2C%20soft%20lighting%2C%20editorial%20quality%2C%20contemporary%20illustration&width=600&height=400&seq=media-1-korean&orientation=landscape',
    icon: 'ri-play-circle-line',
    label: '入门指南',
  },
  {
    title: '日漫经典回顾：那些年我们追过的神作',
    desc: '从Jump黄金时代到当下的热门连载，重温那些影响一代人的经典日本漫画名作。',
    cover: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20Japanese%20manga%20style%20illustration%20with%20classic%20shonen%20characters%20in%20dynamic%20poses%2C%20black%20and%20white%20ink%20style%20with%20warm%20sepia%20accents%2C%20retro%20comic%20magazine%20aesthetic%2C%20action%20lines%2C%20dramatic%20composition%2C%20high%20contrast&width=600&height=400&seq=media-2-japanese&orientation=landscape',
    icon: 'ri-play-circle-line',
    label: '经典回顾',
  },
  {
    title: '国漫推荐：国产漫画的崛起之路',
    desc: '盘点近年最值得关注的国产原创漫画，从古风仙侠到都市科幻，见证国漫的飞速成长。',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese-style%20digital%20illustration%20with%20traditional%20watercolor%20and%20ink%20effects%2C%20a%20mythical%20landscape%20with%20floating%20mountains%20and%20flowing%20clouds%2C%20warm%20golden%20and%20coral%20tones%2C%20anime-influenced%20character%20design%2C%20dreamy%20atmospheric%20lighting%2C%20artistic%20composition&width=600&height=400&seq=media-3-chinese&orientation=landscape',
    icon: 'ri-play-circle-line',
    label: '国漫推荐',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">漫友说</h2>
          <p className="text-sm text-foreground-500">漫画推荐指南与深度解读</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item) => (
            <div key={item.title} className="group rounded-xl overflow-hidden bg-background-100 cursor-pointer">
              <div className="relative overflow-hidden" style={{ aspectRatio: '3/2' }}>
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-foreground-950/20 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500">
                    <i className={`${item.icon} text-3xl`}></i>
                  </div>
                </div>
                <div className="absolute bottom-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-800 text-[10px] font-semibold whitespace-nowrap">{item.label}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-800 mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}